import React   from 'react'
import './home.css'
import Mint from './mint'
import talking from './img/talking.png'
import coin from './img/coin.png'
import url from './img/cool bastards website42 final .mov'


function Home() {


  // const url = `https://pouch.jumpshare.com/preview/LiGP8R7TVTDxjnuN_0Km5Daz5UWXLFrW4Cm2MFG0lspcGQA5ZVTe_7861TM_DCdnpaLNsLMX1djDq6NDeHwJezJprjKJn4snkOQIlHyX-Do`

  return (
        <section className='Hero'>
          <div className='Hero-video-container'>
                <video src={url} 
                autoPlay muted loop
                >

                </video>
          </div> 
          <div className='container'>
              <div className='coin'>
                <img src={coin} alt="" />
              </div>
              <div className='mint-button'>
                <Mint/>
              </div>
              <div className='talking'>
                <img src={talking} alt="" />
              </div> 
          </div>
            
            

        </section>
  )
}

export default Home